import type { SearchResultItem } from '@/data/entities'
import { useDioxusWithProps } from '@/lib/wasm'

interface PreviewPanelProps {
  item: SearchResultItem | null
}

export function PreviewPanel({ item }: PreviewPanelProps) {
  const ref = useDioxusWithProps('mount_preview_panel', {
    item: item
      ? {
          resourceType: item.resourceType,
          title: item.title,
          projectName: item.projectName ?? null,
          score: item.score,
          metadata: item.metadata,
        }
      : null,
  })

  return <div ref={ref} className="contents" />
}
